/* istanbul ignore file */
export type { IconName, Props as IconProps } from './icon'
export { default as Icon } from './icon'
